import React, { useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import websitelogo from '../../../../assets/logos/websitelogo.svg';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import CallIcon from '@mui/icons-material/Call';
import ChatIcon from '@mui/icons-material/Chat';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import MaskInput from 'react-text-mask';
import {
	Box,
	Grid,
	InputAdornment,
	OutlinedInput,
	TextField,
	Typography,
	Button,
	Paper,
	Alert,
	Snackbar,
} from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { Link } from 'react-router-dom';
import { contactUs } from '../../../services/api/apiManager';
import * as Yup from 'yup';
import { InputMask } from '@react-input/mask';
import MaskedInput from 'react-text-mask';

function ContactUs() {
	const defaultTheme = createTheme();
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [errorSnackbar, setErrorSnackbar] = useState(false);
	const [error401Snackbar, setError401Snackbar] = useState(false);

	const schema = Yup.object().shape({
		name: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		Email: Yup.string().matches(
			/^[A-Za-z0-9]+[-A-Za-z0-9._]*@([-A-Za-z0-9]+[^@])+[A-Za-z]{2,5}$/,
			'Wrong Email'
		),
		// ContactNo: Yup.string().matches(
		// 	/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
		// 	'Invalid '
		// ),
	});

	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};

	const [formData, setFormData] = useState({
		Uid: 2147483647,
		name: '',
		ContactNo: '',
		Email: '',
		Subject: '',
		Description: '',
		Status: 'string',
	});
	const handleSubmit = async () => {
		try {
			debugger;
			if (Object.values(formData).some((value) => value === '')) {
				setErrorSnackbar(true);
				return;
			}
			await schema.validate(formData, { abortEarly: false });
			const response = await contactUs(formData);

			// setFormData({
			// 	Uid: 2147483647,
			// 	name: '',
			// 	ContactNo: '',
			// 	Email: '',
			// 	Subject: '',
			// 	Description: '',
			// 	Status: 'string',
			// });

			if (response?.status === 200) {
				setOpenSnackbar(true);
				setTimeout(() => {
					window.location.reload(); // Refresh the page after 2 seconds
				}, 1500);
			} else if (response?.status === 401) {
				setError401Snackbar(true);
			} else {
				setError401Snackbar(true);
			}
		} catch (error) {
			// Optionally, you can add code here to handle errors if needed.
			// setError401Snackbar(true);
		}
	};

	const handleSnackbarClose = () => {
		setOpenSnackbar(false);
		setErrorSnackbar(false);
		setError401Snackbar(false);
	};
	// Check if any field is empty and update error message accordingly

	const handleChange = (event) => {
		debugger;
		const { name, value } = event.target;
		setFormData({ ...formData, [name]: value });
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/background.png')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					padding: '5px 80px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					'@media (max-width: 600px)': {
						padding: '50px 30px',
					},
				}}
			>
				<Grid container item justifyContent="center">
					<Grid
						item
						xs={false}
						sm={6}
						md={6}
						lg={4}
						xl={4}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/singupbacground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							backgroundSize: 'cover',
							display: 'flex',
							flexDirection: 'column',
							borderRadius: '15px 0px 0px 15px',
							justifyContent: 'space-between',
							display: { sm: 'none', xs: 'none', md: 'flex', xl: 'flex' },
						}}
					>
						<Grid
							item
							sx={{
								display: 'flex',
								flex: '1',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
								textAlign: 'center',
							}}
						>
							<Box>
								<Typography
									gutterBottom
									variant="h5"
									sx={{
										color: 'white',
										fontSize: {
											xl: '25px',
											lg: '16px',
											md: '14px',
											sm: '12px',
											xs: '11px',
										},
										fontFamily: 'Poppins',
									}}
								>
									GET IN TOUCH WITH US !
								</Typography>
								<Typography
									variant="h5"
									sx={{
										color: 'white',
										fontSize: {
											xl: '25px',
											lg: '16px',
											md: '14px',
											sm: '12px',
											xs: '11px',
										},
										fontFamily: 'Poppins',
										textAlign: 'center',
										fontWeight: '400',
									}}
								>
									Connect with us for prompt and
									<br /> personalized support
								</Typography>
							</Box>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'space-evenly',
								borderTop: '0.5px solid rgba(255, 255, 255, 0.40)',
								padding: '15px 50px',
							}}
						>
							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1}
							>
								<Grid item>
									<ContactSupportIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/aboutUs'}>
										<Typography
											variant="body1"
											sx={{
												color: 'white',
												fontSize: {
													xl: '16px',
													lg: '13px',
													md: '10px',
													sm: '10px',
													xs: '10px',
												},
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											About Us
										</Typography>
									</Link>
								</Grid>
							</Grid>
							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1}
							>
								<Grid item>
									<CallIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/contactUs'}>
										<Typography
											variant="body1"
											sx={{
												color: 'white',
												fontWeight: '700',
												fontSize: {
													xl: '16px',
													lg: '13px',
													md: '10px',
													sm: '10px',
													xs: '10px',
												},
												textDecoration: 'underline',
											}}
										>
											Contact Us
										</Typography>
									</Link>
								</Grid>
							</Grid>
							{/* <Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1}
							>
								<Grid item>
									<ChatIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/feedback'}>
										<Typography
											variant="body1"
											sx={{
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											Feedback
										</Typography>
									</Link>
								</Grid>
							</Grid> */}
						</Grid>
					</Grid>
					<Grid
						component={Paper}
						elevation={6}
						square
						item
						xs={12}
						sm={12}
						md={6}
						lg={4}
						xl={4}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/formbackground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							borderRadius: '0px 15px 15px 0px',
							dislay: 'flex',
							justifyContent: 'space-between',
							'@media (max-width: 600px)': {
								borderRadius: '15px',
							},
							'@media (max-width: 900px)': {
								borderRadius: '15px',
								justifyContent: 'center',
							},
						}}
					>
						<Box
							sx={{
								margin: '20px 30px 20px 30px',
								display: 'flex',
								flexDirection: 'column',
							}}
						>
							<img
								src={websitelogo}
								alt="Your Alt Text"
								style={{
									maxWidth: '200px',
									height: 'auto',
									objectFit: 'contain',
								}}
							/>
							<Typography
								component="h1"
								variant="h5"
								sx={{
									alignSelf: 'start',
									fontSize: {
										xl: '25px',
										lg: '16px',
										md: '13px',
										sm: '13px',
										xs: '10px',
									},
									fontWeight: '600',
									mt: '5px',
								}}
							>
								Contact Us
							</Typography>
							<Box
								component="form"
								noValidate
								sx={{
									mt: 1,
								}}
							>
								<Grid container spacing={2}>
									<Grid item xs={12} sm={6}>
										<Typography
											variant="body2"
											sx={{ color: '#7E7D7D', fontSize: '15px' }}
										>
											Name
										</Typography>
										<OutlinedInput
											fullWidth
											required
											name="name"
											value={formData.name}
											onChange={handleInputChange}
											endAdornment={
												<InputAdornment position="end">
													<PersonOutlineOutlinedIcon
														sx={{ color: '#DDE6F1' }}
													/>
												</InputAdornment>
											}
											sx={{
												borderRadius: '6px',
												border: '1.5px solid #DDE6F1',
												marginBottom: {
													xl: '8px',
													lg: '4px',
													md: '4px',
													sm: '4px',
													xs: '4px',
												},
												marginTop: {
													xl: '8px',
													lg: '4px',
													md: '4px',
													sm: '4px',
													xs: '4px',
												},
												height: '40px',
												'& .MuiOutlinedInput-input': {
													padding: '5px 0px 5px 6px',
												},
												// boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
											}}
										/>
										{errors.name && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.name}
											</div>
										)}{' '}
										{/* Display validation error */}
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography
											variant="body2"
											sx={{ color: '#7E7D7D', fontSize: '15px' }}
										>
											Contact #
										</Typography>
										{/* <OutlinedInput
											fullWidth
											required
											name="ContactNo"
											value={formData.ContactNo}
											onChange={handleInputChange}
											endAdornment={
												<InputAdornment position="end">
													<CallIcon sx={{ color: '#DDE6F1' }} />
												</InputAdornment>
											}
											sx={{
												borderRadius: '6px',
												height: '40px',
												border: '1.5px solid #DDE6F1',
												marginBottom: '8px',
												marginTop: '8px',
												'& .MuiOutlinedInput-input': {
													padding: '5px 0px 5px 6px',
												},
												// boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
											}}
										/>
										{errors.ContactNo && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.ContactNo}
											</div>
										)}{' '} */}
										{/* <MaskedInput
											mask={[
												'(',
												/\d/,
												/\d/,
												/\d/,
												')',
												' ',
												/\d/,
												/\d/,
												/\d/,
												'-',
												/\d/,
												/\d/,
												/\d/,
												/\d/,
											]} // Specify the mask for the contact number
											className="form-control"
											// placeholder="Enter a phone number"
											guide={false}
											id="my-input-id"
											onBlur={() => {}}
											onChange={handleChange}
											value={formData.ContactNo}
											fullWidth
											required
											name="ContactNo"
											endAdornment={
												<InputAdornment position="end">
													<CallIcon sx={{ color: '#DDE6F1' }} />
												</InputAdornment>
											}
											style={{
												borderRadius: '6px',
												height: '40px',
												border: '0.5px solid lightgray',
												marginBottom: '8px',
												marginTop: '8px',
												'& .MuiOutlinedInput-input': {
													padding: '5px 0px 5px 6px',
												},
												boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
											}}
										/> */}

										<TextField
											variant="outlined"
											// placeholder="Enter a phone number"
											fullWidth
											required
											size="small"
											name="ContactNo"
											value={formData.ContactNo}
											onChange={handleChange}
											InputProps={{
												endAdornment: (
													<InputAdornment position="start">
														<CallIcon sx={{ color: '#DDE6F1' }} />
													</InputAdornment>
												),
												inputComponent: MaskedInput,
												inputProps: {
													mask: [
														'(',
														/\d/,
														/\d/,
														/\d/,
														')',
														' ',
														/\d/,
														/\d/,
														/\d/,
														'-',
														/\d/,
														/\d/,
														/\d/,
														/\d/,
													],
												},
												sx: {
													borderRadius: '6px',
													height: '40px',
													marginBottom: {
														xl: '8px',
														lg: '4px',
														md: '4px',
														sm: '4px',
														xs: '4px',
													},
													marginTop: {
														xl: '8px',
														lg: '4px',
														md: '4px',
														sm: '4px',
														xs: '4px',
													},
													border: '1.5px solid #DDE6F1',
													'& .MuiOutlinedInput-input': {
														padding: '5px 0px 5px 6px',
													},
													// boxShadow:
													// 	'0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
												},
											}}
										/>
										{/* Display validation error */}
									</Grid>
								</Grid>
								{/* value={formData.Email}
								
											inputProps={{
										pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
										title: "Please enter a valid email address"
									  }}

								*/}
								<Typography
									variant="body2"
									sx={{ color: '#7E7D7D', fontSize: '15px' }}
								>
									Email Address
								</Typography>
								<OutlinedInput
									fullWidth
									type="email"
									name="Email"
									value={formData.Email}
									id="email"
									size="small"
									autoComplete="email"
									required
									onChange={handleInputChange}
									endAdornment={
										<InputAdornment position="end">
											<MailOutlineOutlinedIcon sx={{ color: '#DDE6F1' }} />
										</InputAdornment>
									}
									sx={{
										marginBottom: {
											xl: '8px',
											lg: '4px',
											md: '4px',
											sm: '4px',
											xs: '4px',
										},
										marginTop: {
											xl: '8px',
											lg: '4px',
											md: '4px',
											sm: '4px',
											xs: '4px',
										},
										// height: '45px',
										// padding: '5px',
										'& .MuiOutlinedInput-input': {
											// padding: '9px 0px 9px 6px',
											backgroundColor: 'white',
										},
									}}
								/>
								{errors.Email && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.Email}
									</div>
								)}{' '}
								{/* Display validation error */}
								{/* <OutlinedInput
									margin="normal"
									fullWidth
									type="email"
									name="Email"
									value={formData.Email}
									onChange={handleChange}
									required
									id="email"
									inputProps={{
										pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
										title: "Please enter a valid email address"
									  }}
									endAdornment={
										<InputAdornment position="end">
											<MailOutlineOutlinedIcon sx={{ color: '#DDE6F1' }} />
										</InputAdornment>
									}
									sx={{
										borderRadius: '6px',
										border: '1.5px solid #DDE6F1',
										height: '40px',
										marginBottom: '8px',
										marginTop: '8px',
										'& .MuiOutlinedInput-input': {
											padding: '5px 0px 5px 6px',
										},
										// boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
									}}
								/> */}
								<Typography
									variant="body2"
									sx={{ color: '#7E7D7D', fontSize: '15px' }}
								>
									Subject
								</Typography>
								<OutlinedInput
									margin="normal"
									fullWidth
									type="text"
									name="Subject"
									value={formData.Subject}
									onChange={handleChange}
									required
									id="subject"
									endAdornment={
										<InputAdornment position="end">
											<BorderColorOutlinedIcon sx={{ color: '#DDE6F1' }} />
										</InputAdornment>
									}
									sx={{
										borderRadius: '6px',
										height: '40px',
										border: '1.5px solid #DDE6F1',
										marginBottom: {
											xl: '8px',
											lg: '4px',
											md: '4px',
											sm: '4px',
											xs: '4px',
										},
										marginTop: {
											xl: '8px',
											lg: '4px',
											md: '4px',
											sm: '4px',
											xs: '4px',
										},
										'& .MuiOutlinedInput-input': {
											padding: '5px 0px 5px 6px',
										},
										// boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
									}}
								/>
								<Typography
									variant="body2"
									sx={{ color: '#7E7D7D', fontSize: '15px' }}
								>
									Description
								</Typography>
								<TextField
									multiline
									fullWidth
									name="Description"
									value={formData.Description}
									onChange={handleChange}
									rows={2}
									variant="outlined"
									sx={{
										borderRadius: '6px',
										border: '1.5px solid #DDE6F1',
										// boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
									}}
								/>
								<Button
									variant="contained"
									onClick={() => handleSubmit()}
									size="small"
									fullWidth
									sx={{
										background: ' #e87511',
										borderRadius: '6px',
										// height: '40px',
										fontFamily: 'Poppins',
										fontSize: '15px',
										fontWeight: '400',
										marginTop: '20px',
										marginBottom: '5px',
										'&:hover': {
											background: '#e87511',
										},
									}}
								>
									SUBMIT
								</Button>
								<Link to={'/'}>
									<Typography
										variant="body1"
										sx={{
											fontFamily: 'Poppins',
											// color: 'black',
											display: 'flex',
											justifyContent: 'flex-end',
										}}
									>
										{'Login >'}
									</Typography>
								</Link>
							</Box>
						</Box>
					</Grid>
					<Snackbar
						open={openSnackbar}
						autoHideDuration={3000} // Adjust the duration as needed
						onClose={handleSnackbarClose}
						anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					>
						<Alert onClose={handleSnackbarClose} severity="success">
							Recorded successfully.
						</Alert>
					</Snackbar>
					{/* error 401 snackbar */}
					<Snackbar
						open={error401Snackbar}
						autoHideDuration={6000}
						onClose={handleSnackbarClose}
						anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
					>
						<Alert
							onClose={handleSnackbarClose}
							severity="error"
							sx={{
								width: '100%',
								background: 'red',
								color: 'white',
								fontFamily: 'Poppins',
								'& .MuiAlert-icon': {
									color: 'white', // Change icon color to white
								},
							}}
						>
							Error 401
						</Alert>
					</Snackbar>
					{/* empty feilds snackbar */}
					<Snackbar
						open={errorSnackbar}
						autoHideDuration={6000}
						onClose={handleSnackbarClose}
						anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					>
						<Alert
							onClose={handleSnackbarClose}
							severity="error"
							sx={{
								width: '100%',
								background: 'red',
								color: 'white',
								fontFamily: 'Poppins',
								'& .MuiAlert-icon': {
									color: 'white', // Change icon color to white
								},
							}}
						>
							Please fill in all fields.
						</Alert>
					</Snackbar>
				</Grid>{' '}
			</Grid>
		</ThemeProvider>
	);
}

export default ContactUs;
